/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumera los campos que pueden editarse de un evento.
 */
export type EventoPatchFieldsEnum = 'publish' | 'titulo' | 'info' | 'itinerario' | 'incluye' | 'noIncluye' | 'recomendaciones' | 'terminoCondiciones' | 'devoluciones' | 'formatText' | 'fecha' | 'finalizacion' | 'valor' | 'incCupos' | 'categoria' | 'clasificacion';

export const EventoPatchFieldsEnum = {
    Publish: 'publish' as EventoPatchFieldsEnum,
    Titulo: 'titulo' as EventoPatchFieldsEnum,
    Info: 'info' as EventoPatchFieldsEnum,
    Itinerario: 'itinerario' as EventoPatchFieldsEnum,
    Incluye: 'incluye' as EventoPatchFieldsEnum,
    NoIncluye: 'noIncluye' as EventoPatchFieldsEnum,
    Recomendaciones: 'recomendaciones' as EventoPatchFieldsEnum,
    TerminoCondiciones: 'terminoCondiciones' as EventoPatchFieldsEnum,
    Devoluciones: 'devoluciones' as EventoPatchFieldsEnum,
    FormatText: 'formatText' as EventoPatchFieldsEnum,
    Fecha: 'fecha' as EventoPatchFieldsEnum,
    Finalizacion: 'finalizacion' as EventoPatchFieldsEnum,
    Valor: 'valor' as EventoPatchFieldsEnum,
    IncCupos: 'incCupos' as EventoPatchFieldsEnum,
    Categoria: 'categoria' as EventoPatchFieldsEnum,
    Clasificacion: 'clasificacion' as EventoPatchFieldsEnum
};

